module.exports = __webpack_public_path__ + "img/five1Blue.c8252aac.jpg";